"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PIMTokenServiceConfig = exports["default"] = void 0;

var _PIMToken = _interopRequireDefault(require("../models/PIMToken"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var axios = require('axios')["default"];
/**
 * @type {PIMToken}
 * @private
 */


var cachedToken = null;
var PIMTokenServiceConfig = {
  url: '/webservices/productexperience.svc/getPimToken',
  decorateRequest: function decorateRequest(url) {
    var language = getLanguageFromHTML();
    return "".concat(url, "/").concat(language);
  }
};
exports.PIMTokenServiceConfig = PIMTokenServiceConfig;

var getLanguageFromHTML = function getLanguageFromHTML() {
  return document.querySelector('html').getAttribute('lang') || '';
};
/**
 * @type {PIMTokenService}
 * @private
 */


var instance = null;

var PIMTokenService = /*#__PURE__*/function () {
  function PIMTokenService() {
    _classCallCheck(this, PIMTokenService);
  }

  _createClass(PIMTokenService, [{
    key: "getToken",
    value:
    /**
     * @returns {Promise.<PIMToken|Error>}
     */
    function getToken() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (cachedToken && _this.isNotExpired(cachedToken)) {
          resolve(cachedToken);
        } else {
          _this.retrieveTokenFromServer().then(function (token) {
            cachedToken = token;
            resolve(cachedToken);
          })["catch"](function (error) {
            cachedToken = null;
            reject(error);
          });
        }
      });
    }
  }, {
    key: "flushToken",
    value: function flushToken() {
      cachedToken = null;
    }
    /**
     * @private
     * @param {PIMToken} token
     * @returns {boolean}
     */

  }, {
    key: "isNotExpired",
    value: function isNotExpired(token) {
      return new Date() < token.expireDate;
    }
    /**
     * @private
     * @returns {Promise.<PIMToken|Error>}
     */

  }, {
    key: "retrieveTokenFromServer",
    value: function retrieveTokenFromServer() {
      return axios.get(this.resolveURL()).then(function (response) {
        if (response && response.status === 200 && response.data) {
          return _PIMToken["default"].fromJSON(response.data);
        }

        return null; // handle error
      })["catch"](function (error) {
        throw error;
      });
    }
  }, {
    key: "resolveURL",
    value: function resolveURL() {
      if (PIMTokenServiceConfig.decorateRequest) {
        return PIMTokenServiceConfig.decorateRequest(PIMTokenServiceConfig.url);
      }

      return PIMTokenServiceConfig.url;
    }
  }], [{
    key: "instance",
    get: function get() {
      if (!instance) {
        instance = new PIMTokenService();
      }

      return instance;
    }
  }]);

  return PIMTokenService;
}();

var _default = PIMTokenService;
exports["default"] = _default;